import { Component } from '@angular/core';
import { LayoutInitService } from 'src/app/RefModules/_metronic/core';

@Component({
    selector: 'app-instance',
    templateUrl: './instance.component.html',
    styleUrls: ['./instance.component.scss'],
    standalone: false
})
export class InstanceComponent {
    constructor(private layout: LayoutInitService) {
        this.layout.init();
    }
}
